fx.ns("desktop.poster", class PosterEditor extends fx.Component {

	constructor(data) {
		super(data);
	}

	contextMenu(e) {
		return [];
	}

	create() {
		super.create();

		this.mediaTabs = new desktop.poster.MediaTabs(this.data);
		this.addChild(this.mediaTabs, { top: 0, left: 0, width: 340, height: "100%" });

		this.board = new desktop.poster.PosterBoard(this.data, desktop.poster.ComponentFactory);
		this.addChild(this.board, { top: 0, left: 340, width: "100%", height: "100%" });

		this.topBar = new desktop.common.actionbar.TopBar(this.data.creation);
		this.addChild(this.topBar, { top: 20, right: 25, width: 100 });

		this.actionBar = new desktop.common.actionbar.ActionBar(this.data);
		this.addChild(this.actionBar, { top: "center", right: 25, width: 70 });

		this.topNotifications = new desktop.common.TopNotifications(this.data);
		this.topNotifications.visibleAtStart = false;
		this.addChild(this.topNotifications, { top: 10, right: 25 });

		this.dragger = new desktop.common.behaviour.ComponentDragger(this.data, this);

		// Taille · Finition · Aperçu 3D, on top, centred over the poster
		this._settingsContainer = new fx.components.Box("settings");
        this.optionsBar = new desktop.poster.PosterOptionsBar();
        this._settingsContainer.addChild(this.optionsBar, {width : 380, height : 52, top : 0, left : "center"});
		this.addChild(this._settingsContainer);
	}

	onDisplayUpdated() 
    {
		if (this._settingsContainer)
        { 
			this._settingsContainer.viewport({ width: this.board.realWidth - this.topBar.realWidth - this.topBar.right(), height: 50, top: 0, left: this.board.left() });
        }
	}

	onReady() {
		super.onReady();

		this.on("currentAreaChanged", this.onCurrentAreaChanged, this.board);
		this.on("currentElementChanged", this.onCurrentElementChanged, this.board);

		//this.on("photo-extracted", this._onPhotoExtractedFinished, fx.service("MediasUploader").photoExtractor);

		if (this.mediaTabs)
			this.mediaTabs.currentArea = this.board.currentArea;

		this.on("scrolled", this._onScroll, this.board);

		this.on("order", this._onOrder, this.topBar);
		this.on("exit", this._onExit, this.topBar);

		this.on("size", this._onSizeChoice, this.optionsBar);
		this.on("finish", this._onFrameChoice, this.optionsBar);
		this.on("preview3d", this._onWallPreview, this.optionsBar);


		this.listenUpdates(this.data.creation, true);

		// the creation is undeleted on the first modification, not on the opening of the editor
		this.data.undeleteOnFirstUpdate();

        this.delay(this._setWelcomeTips, 500);

        this.data.addPhotosForCreation();    

        this.data.history.start();
	}

	show(callback) {
		super.show(callback);

		fx.set("mode", "edition");
	}

	
	_onOrder() {
		this.data.event("order");
	}

	_onExit() {
		this.data.event("exit-editor");
	}

	_onFrameChoice() {
		this.data.event("frame-choice");
	}

    _onSizeChoice() {
		this.data.event("size-choice");
	}

    _onWallPreview() {
		this.data.event("wall-preview");
	}


	enable() {
		super.enable();
		this.board.enable();
	}

	disable() {
		super.disable();
		this.board.disable();
	}

	onCurrentAreaChanged(e) {
		if (this.mediaTabs)
			this.mediaTabs.currentArea = e.detail;
	}

	onCurrentElementChanged(e) {
		// nothing to do
	}

	onDataEvent(e) {
		switch (e.type) {
			case "switch-photoPanel":
				this.mediaTabs.tabs.selectTab(this.mediaTabs.photoPanel);
				break;

			case "currentAreaChanged":
				this.onCurrentAreaChanged(e);
				break;

		}
	}

	_setWelcomeTips() {
		fx.service("WelcomeTips", { model: this.data, editor: this });

		let notifications = [];

		//if (!this.data.creation.started && this.data.photos.length <= 0 && this.mediaTabs.photoPanel.button)
		//	notifications.push({ trigger: "choose-photos", forbidenComponentClass: "PopupPanel", component: this.mediaTabs.photoPanel.button, title: fx.text("On Commence ?"), text: fx.text("Ajoutez vos photos<br>en cliquant ici"), always: true, start: true });

        if (!this.data.creation.started)
        {
            if (this.data.hasFilteredPhoto)
            {
                let filteredPhoto = this.data.creation.filteredPhoto;
                if (filteredPhoto && !filteredPhoto.hasAIEffect)
                    notifications.push({ trigger: "choose-photo", component: this.board.currentArea, title: fx.text("On Commence ?"), text: fx.text("Recadrez votre photo si besoin"), start: true, always: true, height : 100 });
            }
            else
            if (!this.data.createdFromLayout)
                notifications.push({ trigger: "choose-layout", forbidenComponentClass: "PopupPanel", component: this.mediaTabs, title: fx.text("On Commence ?"), text: fx.text("Choisissez votre modèle<br>Puis ajouter vos photos"), always: true, start: true });
        }

		notifications.push({ trigger: "photo-selected", forbidenComponentClass: "PopupPanel", title: fx.text("Besoin de Recadrer ?"), text: fx.text("Appuyez une seconde fois<br>sur la photo."), width: 320 });
		notifications.push({ trigger: "first-updates", component: this.actionBar.undoButton, title: fx.text("Au cas ou..."), text: fx.text("Vous pouvez annulez vos<br>modifications ici") });

		fx.service("WelcomeTips").notifications(notifications);
	}

});